import { queryOptions } from '@tanstack/react-query';
import { userServiceRepository } from 'services/api/userService/ApiUserServiceRepository';
import type { User } from '@proposify/users-bff-api-client';
import { QueryKeys } from 'utils/queryKeys';

export const userBffQueries = {
  currentUser: queryOptions<User | null>({
    queryKey: QueryKeys.userBffCurrentUser,
    queryFn: async () => {
      try {
        return await userServiceRepository.getCurrentUser();
      } catch {
        // error already tracked inside repository via trackError()
        return null;
      }
    },
    staleTime: Infinity,
  }),
  accountUsers: (accountId: number) =>
    queryOptions<User[]>({
      queryKey: QueryKeys.userBffAccountUsers(accountId),
      queryFn: async () => {
        const { users } = await userServiceRepository.getAccountUsers(accountId);
        return users;
      },
      staleTime: 5 * 60 * 1000,
      retry: false,
    }),
};
